module.exports = __webpack_public_path__ + "media/images/logo_lombard-dd0c95ec.png";